

import {Vue, Component, Prop} from "vue-property-decorator";
import TeacherIcon from "src/modules/teacher/TeacherIcon.vue";
import { getAssetItem } from "src/utils/helpers";

@Component({
  components: {TeacherIcon},
  methods: {getAssetItem}
  })
export default class OnboardingSlide extends Vue {
  @Prop({default: 'onboarding/welcome.webp'}) imageUrl!: string;
  @Prop({type: Boolean, default: false}) noBackButton!: boolean;
  @Prop({type: Boolean, default: false}) hideTeacher!: boolean;
  @Prop({type: Boolean, default: true}) centerContent!: boolean;
  @Prop({type: Boolean, default: false}) contentFade!: boolean;
  @Prop({type: Boolean, default: false}) logoHeader!: boolean;

  private isContentScrolledToEnd: boolean = false;

  mounted() {
    if (this.contentFade) {
      this.$nextTick(() => this.checkContentOverflow());
    }
  }

  private checkContentOverflow() {
    const scrollArea = this.$el.querySelector('#slide-scroll-area');
    const content = this.$el.querySelector('#slide-scroll-area .q-scrollarea__content');
    if (scrollArea && content) {
      this.isContentScrolledToEnd = content.scrollHeight <= scrollArea.clientHeight + 4;
    }
  }

  private onContentScroll(info: {verticalPercentage: number, verticalSize: number, verticalContainerSize: number}) {
    this.isContentScrolledToEnd =
      info.verticalSize <= info.verticalContainerSize + 4 || info.verticalPercentage >= 0.985;
  }
}
